<template>
    <div class="dashBoardBox">
      <div class="indexTop">
          <div class="headBox">
              <div class="headTop">
                <div class="box">
                    <i class="icon icon_logo" @click="goHomePage()"></i>
                    <a href="http://www.aiyechen.com" target="_blank" title="野尘出品" class="ycCopyright">➲ 野尘出品</a>
                    <a href="https://www.aiyechen.com/cpsm.pdf" target="_blank" class="ycDoc" title="使用文档">使用文档</a>
                    <div class="myFavorite" @click="queryMyFavorite">
                        <span>我的收藏</span>
                    </div>
                    <div class="userInfo" @click="goPersonalInfo()">
                        <span class="userNam" >{{userInfo&&userInfo.userName}}</span>
                        <span class="company" >{{userInfo&&userInfo.companyName}}</span>
                        <!-- <span v-if="!isLogin">登录</span> -->
                    </div>
                </div>
              </div>
              <div class="headSearch">
                    <div class="box">
                            <div class="logo"></div>
                            <div class="search">
                                <ul>
                                    <li :class="isSelPro=='company'?'isActive':''" @click="selectBtn('company')">公司</li>
                                    <li :class="isSelPro=='product'?'isActive':''" @click="selectBtn('product')">产品</li>
                                </ul>
                                <div class="searchInp">
                                    <el-input :placeholder="isSelPro=='company'?'请输入公司代码、名称、拼音简称':'请输入产品名称，如动力煤、炼焦煤、焦炭等'" v-model="searchKey" class="input-with-select" @keyup.enter.native="indexSearch"></el-input>
                                    <span @click="indexSearch()" class="btn">搜索</span>
                                </div>
                            </div>
                    </div>
              </div>
              <a href="#downSlide" class="downSlide animated bounce infinite"></a>
          </div>
      </div>
      <div class="indexCenterBox" id="downSlide" >
            <el-tabs v-model="activeName"  v-if="isFlag">
                <el-tab-pane name="first" v-if="!isSearchEnd">
                  <span slot="label">
                  <el-dropdown @command="handleCommand">
                      <span class="el-dropdown-link">
                      {{dropdownName}}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in coreNameList" :key="item" :command="item" >{{item}}产业链</el-dropdown-item>
                      </el-dropdown-menu>
                  </el-dropdown>
                  </span>
                  <ProductAlter v-if="activeName=='first'&&indexSearchInfo.length>0&&isFlag&&hackReset"></ProductAlter>
                </el-tab-pane>
                <!-- <el-tab-pane label="肉鸡产业链" name="first1" v-if="!isSearchEnd">
                    <ProductAlter v-if="activeName=='first1'&&indexSearchInfo.length>0&&isFlag"></ProductAlter>
                </el-tab-pane>
                <el-tab-pane label="生猪产业链" name="first2" v-if="!isSearchEnd">
                    <ProductAlter v-if="activeName=='first2'&&indexSearchInfo.length>0&&isFlag"></ProductAlter>
                </el-tab-pane> -->
                <!-- <el-tab-pane label="公司展望" name="second" v-if="!isSearchEnd">
                    <CompanyOutlook v-if="activeName=='second'&&indexSearchInfo.length>0&&isFlag"></CompanyOutlook>
                </el-tab-pane> -->
                <el-tab-pane :label="isSelPro=='company'?'公司列表':'产品列表'" name="three" v-if="searchKey.trim()!=''&&isSearchEnd">
                    <CompanyList v-if="activeName=='three'&&isSelPro=='company'"></CompanyList>
                    <ProductList v-if="activeName=='three'&&isSelPro=='product'"></ProductList>
                </el-tab-pane>
            </el-tabs>
      </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import ProductAlter from '../components/productAlter.vue'
  import CompanyList from '../components/companyList.vue'
  import CompanyOutlook from '../components/companyOutlook.vue'
  import ProductList from '../components/productList.vue'
  import { error } from 'util'
  import ssUtil from '@/utils/SStorage'
import $ from 'jquery'
import { setTimeout } from 'timers';
  export default {
    name: 'dashBoard',
    data() {
        return {
            isFlag:false,           //请求数据是否结束
            isSearchEnd:false,      //是否搜索结束
            isSelPro:'company',     //是否选择了公司/产品选项
            searchKey:'',           //关键词搜索
            activeName: 'first',    //底部详细图片选择的那个Tab
            hackReset: true,        //强制刷新productAlter
            coreNameList: [],       //行业产业链名称数组
            dropdownName:'钢铁产业链',
        }
    },
    components:{ProductAlter,CompanyList,CompanyOutlook,ProductList},
    computed:{...mapState(['isLogin','userInfo','indexSearchInfo','proPageSearchParams','coreName'])},
    created(){
        this.$store.dispatch('setLoginState', ssUtil.getItem('isLogin'))
        this.$store.dispatch('userInfo', ssUtil.getItem('userInfo'))
        if( this.proPageSearchParams.flag &&this.proPageSearchParams.flag == 'productInfo'){
            this.isSelPro = this.proPageSearchParams.searchTab
            this.isSearchEnd = true;
            this.searchKey = this.proPageSearchParams.searchKey;
            this.activeName =  'three'
        }
    },
    methods: {
        //获取产品异动信息
        // getSingularProduct(){
        //     this.$store.dispatch('getSingularProduct').then( res => {
        //         if( res.data.retCode == '000'){
        //            this.$store.dispatch( 'indexSearchInfo' , res.data.data)
        //            this.isFlag = true;
        //         }
        //     })
        // },
        //产品异动公司关联
        getProductRemind(){
            this.$store.dispatch('getProductRemind',{coreName:this.coreName}).then( res => {
                if( res.data.retCode == '000'){
                   this.$store.dispatch( 'indexSearchInfo' , res.data.data)
                   this.isFlag = true;
                   this.hackReset = false
                   this.hackReset = false
                   this.$nextTick(() => {
                    this.hackReset = true
                  })
                }
            })
        },
        //获取公司展望信息
        getCompanyProspect(){
            this.$store.dispatch('getCompanyProspect').then( res => {
                if( res.data.retCode == '000'){
                   this.$store.dispatch( 'indexSearchInfo' , res.data.data)
                   this.isFlag = true;
                }
            })
        },
        //切换产品和公司
        selectBtn(str){
            this.isSelPro = str;
            this.searchKey = ''
        },
        //关键词搜索
        indexSearch(){
            if(!this.searchKey||this.searchKey.trim()==''){
              this.$message({
                message:'搜索值不能为空',
                type:'error',
                center:true,
                showClose:false
              })
              return;
            }
            let urlParams = '';
            if( this.isSelPro == 'product'){
                urlParams = 'productSearch';
            }else if( this.isSelPro == 'company'){
                urlParams = 'companySearch'
            }

            this.$store.dispatch( urlParams , { keyword: this.searchKey }).then( res => {
                if( res.data.retCode == '000'){
                    let resultData = res.data.data
                    this.$store.dispatch( 'indexSearchInfo' , resultData)
                    this.isSearchEnd = true;
                    this.activeName = 'three';
                    if( resultData.length == 1 ){
                        if( this.isSelPro == 'product'){
                            let params = {
                                type: 'product',
                                productCode: resultData[0].productCode,
                                name: resultData[0].productName,
                                industry: resultData[0].industry
                              }
                            this.$router.push({name:'productInfo',params: params})
                        }else if(this.isSelPro == 'company'){
                            let params = {
                                type: 'company',
                                coCode :resultData[0].coCode,
                                securityCode:resultData[0].securityCode,
                                name: resultData[0].securityName
                            }
                            this.$router.push({name:'productInfo',params: params})
                        }
                    }
                }
            })
        },
        //返回首页
        goHomePage(){
            this.$router.push({
                path:'/dashBoard'
            })
        },
        //进入个人中心或者登录页
        goPersonalInfo(){
            if( this.isLogin ){
                //个人中心
                this.$router.push({
                    path:'/personal'
                })
            }else{
                //登录页面
                this.$router.push({
                    path:'/login'
                })
            }
        },
        handleCommand(command){
            this.$store.dispatch( 'setCoreName' , command)
            this.dropdownName = command+'产业链'
            this.getProductRemind();
        },
        getCoreNameInfo(){
            this.$store.dispatch('getCoreNameInfo').then( res => {
                this.$store.dispatch( 'setCoreName' , res.data.data.defaultCoreName)
                this.coreNameList = res.data.data.coreNameList
                let that = this
                if( this.activeName == 'first'){
                    this.$nextTick(function(){
                        // that.getSingularProduct();
                        that.getProductRemind();
                    })
                }
            })
        },
        queryMyFavorite(){
            this.$router.push({path:'/myFavorite'})
        },

    },
    mounted() {
        this.getCoreNameInfo()
    },
    watch:{
        isLogin(val,oldVal){
          if(!this.isLogin){
            this.$router.push({
                path:'/login'
            })
          }
        },
        activeName(val,oldVal){
            if( this.activeName == 'first' ){
                // this.getSingularProduct();
                // this.$store.dispatch( 'setCoreName' , '肉鸡')
                this.getProductRemind();
            }else if(this.activeName == 'three'){
                // let anchor = document.querySelector('#downSlide')
                let anchor = this.$el.querySelector('#downSlide')
                document.documentElement.scrollTop = anchor.offsetTop
            }
        },
        searchKey(val,oldVal){
            if( this.searchKey.trim() == '' ){
                this.isSearchEnd = false;
                this.$store.dispatch('proPageSearchParams',{})
                this.isFlag = false;
                this.activeName = 'first';
                // this.getSingularProduct();
                // this.$store.dispatch( 'setCoreName' , '肉鸡')
                this.getProductRemind();
            }else{
                if( this.isFlag == false){
                    this.isFlag = true;
                    this.$nextTick( function(){
                        $(window).scrollTop(970)
                    })
                }

            }
        },
    },
    destroyed(){
        this.$store.dispatch('proPageSearchParams',{})
    }
  }
</script>

<style lang="scss" src="../sass/dashBoard.scss" ></style>



// WEBPACK FOOTER //
// src/view/dashBoard.vue